import { Fancybox } from "@fancyapps/ui";

export default function initGallery(el: string) {
    Fancybox.bind(document.querySelector(el), 'a', {
        // ...options
    });
}